export enum Role {
  ADMIN                    = 'Administrateur',
  MANAGER                  = 'Manager',
  USER                     = 'Client standard',
  LIVREUR                  = 'Livreur',
  RESPONSABLE_ZONE         = 'Responsable de zone',
  COMPTABLE_ZONE           = 'Comptable de zone',
  COMPTABLE_GENERAL        = 'Comptable général',
  RESPONSABLE_MATERIEL     = 'Responsable matériel',
  RESPONSABLE_RH           = 'Responsable RH',
  COMPTABLE                = 'Comptable',
  GESTIONNAIRE_PARTENARIATS = 'Gestionnaire partenariats'
}
